import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=767a73c0&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=767a73c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a73c0",
  null
  
)

export default component.exports